import React, { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const NAV = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Über Uns", href: "#ueber-uns" },
  { label: "Prozess", href: "#prozess" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-zinc-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src={scrolled ? "/assets/honex-mark.svg" : "/assets/honex-mark-white.svg"}
            alt="Honex GmbH"
            className="h-9 md:h-11 w-auto select-none transition-opacity"
            draggable={false}
          />
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s|ü/g, "-")}`}
              className={`px-4 py-2 text-sm font-bold uppercase tracking-widest transition-colors hover:text-red-500 ${
                scrolled ? "text-zinc-700" : "text-white/90"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#kontakt"
            data-testid="header-cta"
            className="hidden md:inline-flex items-center gap-2 bg-red-600 text-white px-5 py-3 text-xs font-bold uppercase tracking-widest hover:bg-red-700 transition-colors"
          >
            Angebot anfragen <ArrowUpRight className="w-4 h-4" />
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menü öffnen"
            className={`lg:hidden w-10 h-10 flex items-center justify-center border ${
              scrolled
                ? "border-zinc-300 text-zinc-900"
                : "border-white/40 text-white"
            }`}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-zinc-200"
        >
          <div className="px-4 py-4 flex flex-col">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s|ü/g, "-")}`}
                className="py-3 text-sm font-bold uppercase tracking-widest text-zinc-800 border-b border-zinc-100 hover:text-red-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta"
              className="mt-4 inline-flex items-center justify-center gap-2 bg-zinc-900 text-white px-5 py-4 text-xs font-bold uppercase tracking-widest"
            >
              Angebot anfragen <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
